// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2jFcv","disabled":"FileBtn_disabled__1fWGo","warn":"FileBtn_warn__1rP0f","fade":"FileBtn_fade__1MsTV"};